import { MagnifyingGlass as Search } from "@phosphor-icons/react";
import { forwardRef } from "react";
import type { InputHTMLAttributes } from "react";
import { Input } from "./Input";

export const SearchInput = forwardRef<HTMLInputElement, InputHTMLAttributes<HTMLInputElement> & { containerClassName?: string }>(function SearchInput({ className, containerClassName, ...props }, ref) {
  return (
    <Input
      type="search"
      placeholder="Search creators, assets, studios..."
      leadingIcon={<Search size={16} weight="regular" aria-hidden="true" />}
      ref={ref}
      className={className}
      containerClassName={containerClassName}
      {...props}
    />
  );
});
